import { useContext } from 'react';
import { AppContext } from '../../../context/AppProvider';
import withRegtrationToken from '../../common/withRegtrationToken';
import EditProfileFrom from '../edit-profile/EditProfileFrom';
 
const UserProfile = () => {
  const {state} = useContext(AppContext);
  return <>{state.user && <EditProfileFrom newUser />}</>;
};

export default withRegtrationToken(UserProfile);
